import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthDialog } from "@/components/AuthDialog";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [authOpen, setAuthOpen] = useState(true);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
        <Lock className="mb-4 h-10 w-10 text-primary" />
        <h2 className="font-display text-4xl tracking-wider">Members Only</h2>
        <p className="mt-2 max-w-md text-foreground/60">Sign in to track your challenges, save ideas and join the leaderboard.</p>
        <Button onClick={() => setAuthOpen(true)} className="mt-6 rounded-sm bg-primary font-bold uppercase tracking-widest">Sign In</Button>
        <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
